const PATH = 'fe.components.rich_text_editor';

const messages = {
  toolbar: {
    bold: {
      key: `${PATH}.toolbar.bold`,
      defaultValue: 'Bold'
    },
    italic: {
      key: `${PATH}.toolbar.italic`,
      defaultValue: 'Italic'
    },
    underline: {
      key: `${PATH}.toolbar.underline`,
      defaultValue: 'Underline'
    },
    bulletedList: {
      key: `${PATH}.toolbar.bulleted_list`,
      defaultValue: 'Bulleted list'
    },
    numberedList: {
      key: `${PATH}.toolbar.numbered_list`,
      defaultValue: 'Numbered list'
    },
    link: {
      key: `${PATH}.toolbar.link`,
      defaultValue: 'Insert link'
    },
    heading: {
      key: `${PATH}.toolbar.heading`,
      defaultValue: 'Heading'
    }
  }
};

export default messages;
